import { memo } from 'react';
import classNames from '@/utils/classNames';

type IconProps = {
  className?: string;
};
const Icon = ({ className }: IconProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames('text-greyscale-950', className)}
  >
    <path
      d="M5.28403 0H0V13.2712L4.72693 18H9.80838V4.55932L5.28403 0ZM12.5601 0L17.0845 4.55932V18H11.9861L7.27609 13.2712V0H12.5601Z"
      className="fill-current"
    />
  </svg>
);

export default memo(Icon);
